import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormGroup, Input, Label } from "reactstrap";
import { useHistory } from "react-router-dom";
import { C_Button } from "../../components/Common/CommonButton";
import { C_DatePicker, C_Select } from "../../CustomValidateForm";
import * as _cfunc from "../../components/Common/CommonFunction";
import { mode, pageId, url } from "../../routes/index"
import { MetaTags } from "react-meta-tags";
import C_Report from "../../components/Common/C_Report";
import { StockProcessing_API_Success, StockProcessing_Action, stockReport_1_GoButton_API, stockReport_1_GoButton_API_Success } from "../../store/Report/StockReport/action";
import { commonPageField, commonPageFieldSuccess, Get_Items_Drop_Down, getBaseUnit_ForDropDown, getBaseUnit_ForDropDownSuccess, getpdfReportdata } from "../../store/actions";
import { customAlert } from "../../CustomAlert/ConfirmDialog";
import { LastStockEntryDate_API, Pos_StockReport_GoBtn_API, StockReport_1_GoBtn_API } from "../../helpers/backend_helper";
import * as report from '../ReportIndex'
import { ExcelReportComponent } from "../../components/Common/ReportCommonFunc/ExcelDownloadWithCSS";
import { alertMessages } from "../../components/Common/CommonErrorMsg/alertMsg";
import { changeCommonPartyDropDetailsAction } from "../../store/Utilites/PartyDrodown/action";
import { allLabelWithBlank, allLabelWithZero } from "../../components/Common/CommonErrorMsg/HarderCodeData";
import { columns, Rows, setShowActualAmount } from "../StockReport/PDFReport/TableData";
import { getCategorylist } from "../../store/Administrator/CategoryRedux/action";



const SNSReport = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const currentDate_ymd = _cfunc.date_ymd_func();
    const isSCMParty = _cfunc.isAdminDivisionRole();
    const isFranchises = (_cfunc.loginUserIsFranchisesRole() || _cfunc.loginUserIsCBMAttribRole());
    const [lastStockEntryDate, setLastStockEntryDate] = useState("");
    const [headerFilters, setHeaderFilters] = useState('');
    const [userPageAccessState, setUserAccState] = useState('');
    const [unitDropdown, setUnitDropdown] = useState({ value: 0, label: "BaseUnit" });
    const [PartyDropdown, setPartyDropdown] = useState([allLabelWithBlank]);
    const [btnMode, setBtnMode] = useState("");
    const [categoryDropdown, setCategoryDropdown] = useState(allLabelWithZero);
    const isSweetAndSnacksCompany = _cfunc.IsSweetAndSnacksCompany();

    const reducers = useSelector(
        (state) => ({
            goBtnLoading: state.PdfReportReducers.goBtnLoading,
            excelLoading: state.StockReportReducer.SR_GoBtnLoading,
            stockProcessingLoading: state.StockReportReducer.stockProcessingLoading,
            StockProcessingBtn: state.StockReportReducer.StockProcessingBtn,
            StockReport_1_Gobtb: state.StockReportReducer.StockReport_1_Gobtb,
            party: state.CommonPartyDropdownReducer.commonPartyDropdownOption,
            pdfdata: state.PdfReportReducers.pdfdata,
            BaseUnit: state.ItemMastersReducer.BaseUnit,
            categoryList: state.CategoryReducer.CategoryListData,
            userAccess: state.Login.RoleAccessUpdateData,
            pageField: state.CommonPageFieldReducer.pageField,
        })
    );
    const { StockReport_1_Gobtb, pdfdata, pageField, party, goBtnLoading, excelLoading } = reducers;
    const { userAccess, BaseUnit, StockProcessingBtn } = reducers;
    const { fromdate = currentDate_ymd, todate = currentDate_ymd } = headerFilters;

    const location = { ...history.location };
    const hasShowModal = props.hasOwnProperty(mode.editValue);

    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;
        if (hasShowModal) {
            locationPath = props.masterPath;
        }
        userAcc = userAccess.find((inx) => (`/${inx.ActualPagePath}` === locationPath));
        if (userAcc) {
            setUserAccState(userAcc);
            _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
        }
    }, [userAccess]);

    useEffect(() => {
        const getLastStockEntryDate = async () => {
            try {

                let PartyID = _cfunc.loginPartyID();

                if (isSCMParty || _cfunc.loginUserIsCBMAttribRole()) {
                    const selectedParty =
                        PartyDropdown?.filter(i => i.value !== "") || [];

                    if (selectedParty.length === 1) {
                        PartyID = selectedParty[0].value;
                    } else {
                        setLastStockEntryDate("");
                        return;
                    }
                }

                const response = await LastStockEntryDate_API({
                    jsonBody: JSON.stringify({
                        PartyID,
                        IsFranchises: isFranchises ? 1 : 0
                    })
                });

                if (response?.StatusCode === 200) {
                    setLastStockEntryDate(response.Data);
                }

            } catch (error) {
                console.log("Last Stock Entry Date Error :", error);
            }
        };

        getLastStockEntryDate();

    }, [PartyDropdown]);

    useEffect(() => {
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(pageId.STOCK_REPORT_1));
        dispatch(getBaseUnit_ForDropDown());
        if (_cfunc.CommonPartyDropValue().value > 0) {
            setPartyDropdown([_cfunc.CommonPartyDropValue()]);
        }
        dispatch(changeCommonPartyDropDetailsAction({ isShow: false }));
        return () => {
            dispatch(commonPageFieldSuccess(null));
            dispatch(stockReport_1_GoButton_API_Success([]));
            dispatch(getBaseUnit_ForDropDownSuccess([]));
            dispatch(changeCommonPartyDropDetailsAction({ isShow: true }));
        };
    }, []);

    useEffect(() => {
        dispatch(getCategorylist());
    }, []);

    const Category_Options = [
        allLabelWithZero,
        ...(reducers.categoryList || []).map(i => ({ value: i.id, label: i.Name }))
    ];

    const extraColumn = () => {
        if (isSweetAndSnacksCompany) {
            // CSS
            return [
                "PartyName",
                "GroupName",
                "SubGroupName",
                "ItemName",
                "Item_id",
                "OpeningBalance",
                "GRNInward",
                "IBPurchase",
                "MaterialIssue",
                "Production",
                "IBSale",
                "SalesReturn",
                "Sale",
                "PurchaseReturn",
                "Wastage",
                "ReIssue",
                "ReProcess",
                "StockAdjustment",
                "ClosingBalance",
                "ClosingAmount",
                "ActualStock",
                "UnitName",
            ];
        }

        // CBM
        return [
            "PartyName",
            "GroupName",
            "SubGroupName",
            "ItemName",
            "SAPCode",
            "Item_id",
            "OpeningBalance",
            "GRNInward",
            "SalesReturn",
            "Sale",
            "PurchaseReturn",
            "Wastage",
            ...(isFranchises ? ["ToleranceQuantity"] : []),
            "StockAdjustment",
            "ClosingBalance",
            "ClosingAmount",
            "ActualStock",
            "UnitName",
        ];
    };

    useEffect(() => {

        try {
            if ((StockReport_1_Gobtb.Status === true) && (StockReport_1_Gobtb.StatusCode === 200)) {
                const partyName = StockReport_1_Gobtb?.Data?.[0]?.PartyName || "";
                const StockDetails = StockReport_1_Gobtb.Data.flatMap(entry =>
                    entry.StockDetails.map(stock => ({
                        ...stock,
                        PartyName: entry.PartyName,
                        ClosingBalance: (stock.ClosingBalance === null ? (0).toFixed(2) : stock.ClosingBalance),
                        ActualStock: (stock.ActualStock === null ? (0).toFixed(3) : stock.ActualStock),
                    }))
                );
                if (btnMode === "excel") {

                    const listExcelDownload = extraColumn()

                    ExcelReportComponent({
                        pageField, excelTableData: StockDetails, excelFileName: "SNS Report", listExcelDownload: listExcelDownload,
                        style: { ySplit: 1 }
                    });

                    dispatch(stockReport_1_GoButton_API_Success([]));
                }
            } else if ((StockReport_1_Gobtb.Status === true) && (StockReport_1_Gobtb.StatusCode === 204)) {
                customAlert({ Type: 3, Message: StockReport_1_Gobtb.Message });
                dispatch(stockReport_1_GoButton_API_Success([]));
                return;
            }
        } catch (e) { }
    }, [StockReport_1_Gobtb]);

    useEffect(() => {
        try {
            if (btnMode === "print") {
                if ((pdfdata.Status === true) && (pdfdata.StatusCode === 204)) {
                    customAlert({ Type: 3, Message: alertMessages.recordNotAvailable });
                    return;
                }
            }
            dispatch(stockReport_1_GoButton_API_Success([]));
        } catch (e) { }
    }, [pdfdata]);

    useEffect(async () => {
        if ((StockProcessingBtn.Status === true) && (StockProcessingBtn.StatusCode === 200)) {
            dispatch(StockProcessing_API_Success([]));
            customAlert({ Type: 1, Message: StockProcessingBtn.Message });
        } else if (StockProcessingBtn.Status === true) {
            dispatch(StockProcessing_API_Success([]));
            customAlert({ Type: 4, Message: JSON.stringify(StockProcessingBtn.Message) });
        }
    }, [StockProcessingBtn]);

    const Party_Option = party.map(i => ({ value: i.id, label: i.Name }));

    const BaseUnit_DropdownOptions = BaseUnit
        .filter(index => index.Name === "No" || index.Name === "Kg" || index.Name === "Box")
        .map(data => ({ value: data.id, label: data.Name }));
    BaseUnit_DropdownOptions.unshift({ value: 0, label: "BaseUnit" });

    // Count real (non-blank) selected parties — drives party field width growth
    const selectedPartyCount = PartyDropdown.filter(i => i.value !== '').length;

    // Grows 90px per additional pill, capped at 560px
    const partyMaxWidth = selectedPartyCount === 0
        ? 260
        : Math.min(260 + selectedPartyCount * 90, 560);

    function onChangeParty(e = []) {
        if (e.length === 0) {
            e = [allLabelWithBlank];
        } else {
            e = e.filter(i => !(i.value === ''));
        }
        setPartyDropdown(e);
    }

    function StockProccessHandler() {

        const selectedParties = PartyDropdown.filter(
            i => i.value !== "" && i.value !== 0
        );

        if (isSCMParty) {

            if (selectedParties.length === 0) {
                customAlert({
                    Type: 3,
                    Message: alertMessages.commonPartySelectionIsRequired
                });
                return;
            }

            if (selectedParties.length > 1) {
                customAlert({
                    Type: 3,
                    Message: "Only single party is allowed for Stock Process"
                });
                return;
            }
        }

        const btnId = `gobtn-${url.STOCK_REPORT_1}`;

        const jsonBody = JSON.stringify({
            FromDate: fromdate,
            ToDate: todate,
            Party: isSCMParty
                ? selectedParties[0].value
                : _cfunc.loginPartyID()
        });

        dispatch(
            StockProcessing_Action({
                jsonBody,
                btnId,
                isFranchises
            })
        );
    }

    function excel_And_GoBtnHandler(e, btnMode) {
        setBtnMode(btnMode);
        if (unitDropdown === "") {
            customAlert({ Type: 4, Message: alertMessages.selectUnit });
            return;
        }
        if ((isSCMParty) && (PartyDropdown === "")) {
            customAlert({ Type: 4, Message: alertMessages.commonPartySelectionIsRequired });
            return;
        }
        const PartyIDs = PartyDropdown?.filter(i => !(i.value === '')).map(obj => obj.value).join(',');
        const finalPartyIDs = (PartyIDs === '') ? Party_Option?.map(obj => obj.value).join(',') : PartyIDs;
        const CategoryType = categoryDropdown?.value ?? 0;
        const jsonBody = JSON.stringify({
            "FromDate": fromdate,
            "ToDate": todate,
            "Unit": unitDropdown.value,
            "CategoryType": CategoryType,
            "Party": isSCMParty ? finalPartyIDs : _cfunc.loginPartyID().toString(),
            "ShowActualStock": headerFilters.ShowActualStock ? 1 : 0
        });
        let config = { ReportType: report.Stock, jsonBody, CategoryName: categoryDropdown?.label };
        if (btnMode === "excel") {
            dispatch(stockReport_1_GoButton_API(config));
            return;
        }
        dispatch(getpdfReportdata(StockReport_1_GoBtn_API, config));
    }

    function fromdateOnchange(e, date) {
        let newObj = { ...headerFilters };
        newObj.fromdate = date;
        setHeaderFilters(newObj);
    }

    function todateOnchange(e, date) {
        let newObj = { ...headerFilters };
        newObj.todate = date;
        setHeaderFilters(newObj);
    }

    /* shared label style */
    const labelStyle = { fontSize: "12px", fontWeight: 500, whiteSpace: "nowrap", marginBottom: "5px" };
    const validSelectedParties = PartyDropdown.filter(i => i.value !== "" && i.value !== 0);
    const showLastStockDate = !isSCMParty || validSelectedParties.length === 1;

    // Current Financial Year: 1 April to 31 March
    const currentFYStart = new Date();
    const currentYear = currentFYStart.getFullYear();
    const currentMonth = currentFYStart.getMonth(); // Jan = 0, Apr = 3

    if (currentMonth < 3) {
        currentFYStart.setFullYear(currentYear - 1);
    }
    currentFYStart.setMonth(3, 1);
    currentFYStart.setHours(0, 0, 0, 0);

    const currentFYEnd = new Date(currentFYStart);
    currentFYEnd.setFullYear(currentFYStart.getFullYear() + 1);
    currentFYEnd.setMonth(2, 31);
    currentFYEnd.setHours(23, 59, 59, 999);

    const selectedFromDate = fromdate ? new Date(fromdate) : null;
    const selectedToDate = todate ? new Date(todate) : null;

    const isCurrentFinancialYear =
        selectedFromDate &&
        selectedToDate &&
        selectedFromDate >= currentFYStart &&
        selectedToDate <= currentFYEnd;

    return (
        <>
            <MetaTags>{_cfunc.metaTagLabel(userPageAccessState)}</MetaTags>

            <div className="px-2 c_card_filter text-black mb-1">

                {/* ── Row 1: filters ── */}
                <div
                    className="d-flex align-items-start flex-wrap mt-1 mb-2"
                    style={{ gap: "6px 0" /* row-gap only; column spacing done by FieldDivider */ }}
                >

                    {/* From Date */}
                    <div style={{ flex: "0 0 auto", padding: "0 16px 0 0" }}>
                        <FormGroup className="mb-0">
                            <Label className="mb-1" style={labelStyle}>From Date</Label>
                            <C_DatePicker
                                name="fromdate"
                                value={fromdate}
                                onChange={fromdateOnchange}
                            />
                        </FormGroup>
                    </div>

                    {/* To Date */}
                    <div style={{ flex: "0 0 auto", padding: "0 16px" }}>
                        <FormGroup className="mb-0">
                            <Label className="mb-1" style={labelStyle}>To Date</Label>
                            <C_DatePicker
                                name="todate"
                                value={todate}
                                onChange={todateOnchange}
                            />
                        </FormGroup>
                    </div>


                    {/* Unit */}
                    <div style={{ flex: "0 0 160px", padding: "0 16px" }}>
                        <FormGroup className="mb-0">
                            <Label className="mb-1" style={labelStyle}>Unit</Label>
                            <C_Select
                                name="Unit"
                                value={unitDropdown}
                                isSearchable={true}
                                className="react-dropdown"
                                classNamePrefix="dropdown"
                                options={BaseUnit_DropdownOptions}
                                onChange={(e) => setUnitDropdown(e)}
                            />
                        </FormGroup>
                    </div>

                    {/* Category — Sweet & Snacks only */}
                    {isSweetAndSnacksCompany && (
                        <>
                            <div style={{ flex: "0 0 160px", padding: "0 16px" }}>
                                <FormGroup className="mb-0">
                                    <Label className="mb-1" style={labelStyle}>Category</Label>
                                    <C_Select
                                        name="Category"
                                        value={categoryDropdown}
                                        isSearchable={true}
                                        className="react-dropdown"
                                        classNamePrefix="dropdown"
                                        options={Category_Options}
                                        onChange={(e) => setCategoryDropdown(e)}
                                    />
                                </FormGroup>
                            </div>
                        </>
                    )}

                    {/* Party — SCM only, grows with pill count */}
                    {isSCMParty && (
                        <>
                            <div
                                style={{
                                    flex: "1 1 180px",
                                    minWidth: "180px",
                                    maxWidth: `200px`,
                                    padding: "0 16px",
                                    transition: "max-width 0.2s ease",
                                }}
                            >
                                <FormGroup className="mb-0">
                                    <Label className="mb-1" style={labelStyle}>Party</Label>
                                    <C_Select
                                        name="Party"
                                        value={PartyDropdown}
                                        isMulti={true}
                                        isSearchable={true}
                                        className="react-dropdown"
                                        classNamePrefix="dropdown"
                                        styles={{
                                            menu: (provided) => ({ ...provided, zIndex: 3 }),
                                            container: (provided) => ({ ...provided, width: "100%" }),
                                        }}
                                        options={Party_Option}
                                        onChange={(e) => onChangeParty(e)}
                                    />
                                </FormGroup>
                            </div>
                        </>
                    )}

                    {/* Actual Stock — always pinned to far right */}
                    <div style={{ flex: "0 0 auto", marginLeft: "20px" }}>
                        <FormGroup className="mb-0">
                            {/* invisible spacer keeps checkbox row aligned with inputs */}
                            <Label className="mb-1 d-block" style={{ ...labelStyle, visibility: "hidden" }}>_</Label>
                            <div
                                className="d-flex align-items-center"
                                style={{ gap: "7px", height: "38px" }}
                            >
                                <Input
                                    id="showActualStock"
                                    type="checkbox"
                                    checked={headerFilters.ShowActualStock || false}
                                    style={{ cursor: "pointer", transform: "scale(1.1)", marginTop: 0 }}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setHeaderFilters((prev) => ({ ...prev, ShowActualStock: checked }));
                                        setShowActualAmount(checked);
                                    }}
                                />
                                <Label
                                    htmlFor="showActualStock"
                                    className="mb-0"
                                    style={{ cursor: "pointer", whiteSpace: "nowrap", fontSize: "13px" }}
                                >
                                    Actual Stock
                                </Label>
                            </div>
                        </FormGroup>
                    </div>

                </div>

                {/* ── Divider ── */}
                <hr className="mt-0 mb-2" />

                {/* ── Row 2: Last Stock Entry left | buttons right ── */}
                <div className="d-flex align-items-center pb-1">
                    {showLastStockDate && (
                        <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                            <Label className="mb-0 fw-bold" style={{ whiteSpace: "nowrap", fontSize: "13px" }}>
                                Last Stock Entry :
                            </Label>
                            <Label className="mb-0" style={{ whiteSpace: "nowrap", fontSize: "13px" }}>
                                {lastStockEntryDate &&
                                    lastStockEntryDate !== "" &&
                                    lastStockEntryDate !== undefined
                                    ? _cfunc.date_dmy_func(lastStockEntryDate)
                                    : "—"}
                            </Label>
                        </div>
                    )}
                    <div className="d-flex align-items-center ms-auto" style={{ gap: "8px" }}>
                        <div
                            style={{
                                cursor: !isCurrentFinancialYear ? "not-allowed" : "pointer",
                                display: "inline-block"
                            }}
                        >
                            <C_Button
                                type="button"
                                spinnerColor="white"
                                loading={reducers.stockProcessingLoading}
                                className="btn btn-info"
                                forceDisabled={!isCurrentFinancialYear}
                                onClick={() => StockProccessHandler()}
                            >
                                Stock Process
                            </C_Button>
                        </div>

                        <C_Button
                            type="button"
                            spinnerColor="white"
                            className="btn btn-success"
                            loading={goBtnLoading}
                            onClick={(e) => excel_And_GoBtnHandler(e, "print")}
                        >
                            Print
                        </C_Button>

                        <C_Button
                            type="button"
                            spinnerColor="white"
                            loading={excelLoading}
                            className="btn btn-primary"
                            onClick={(e) => excel_And_GoBtnHandler(e, "excel")}
                        >
                            Excel
                        </C_Button>
                    </div>

                </div>

            </div>

            <C_Report />
        </>
    );
};

export default SNSReport;